<template>
  <div
    :class="[
      'content-boxes',
      dimensions.width > 600 ? 'py-xl' : 'pt-2xl pb-l',
      css
    ]"
  >
  <!--
    <a href="#p" v-for="item in children" :key="item.title" class="content-boxes--item text-left text-gray-7"
      :class="[properties.bg || 'bg-gray-1']"
      @click.prevent="updatePopup(item)">

    -->
    <a :href="item.url" v-for="item in children" :key="item.title" class="content-boxes--item text-left text-gray-7"
      :class="[properties.bg || 'bg-gray-1']">

      <div class="content-boxes--item--image" :style="imageStyle(item)"></div>
      <div
        class="content-boxes--item--content"
        :class="[
          dimensions.width > 1024 ? 'p-l' : 'p-m',
          properties.centerLabel ? 'text-center' : ''
        ]"
      >
        <h4
          class="font-rg"
          :class="[
            properties.titleColor || 'text-gray-8',
            properties.titleSize || ''
          ]"
          v-text="item.title"
        ></h4>
        <p
          v-if="item.sub_title"
          class="summary"
          :class="[
            properties.textColor || 'text-gray-8',
            properties.textSize || ''
          ]"
          v-text="item.sub_title"
        ></p>
      </div>
    </a>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  props: {
    children: {
      type: Array,
      required: true
    },
    css: String,
    properties: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      interval: -1,
      timeout: -1,
      avg: 50,
      min: 48,
      max: 52,
      activeProfile: null
    };
  },
  methods: {
    ...mapActions(["updatePopup"]),
    imageStyle(item) {
      return `background-image: url(${this.$imageFolder}/${item.image})`;
    },
    openProfile(item) {
      this.activeProfile = item;
    }
  },
  computed: {
    ...mapState(["dimensions"])
  }
};
</script>

<style lang="stylus" scoped>
.content-boxes
  position relative
  z-index 11
  _flex(row, wrap, stretch, flex-start)
  &--item
    _flex(column, nowrap, flex-start, stretch)
    border-right 20px solid #fff
    transition background 0.3s ease-out
    &--content
      width 100%
      _flex(column, nowrap, flex-start,center)
      &.text-center
        _flex(column, nowrap, center,center)
    &--image
      width 100%
      padding-top 90%
      position relative
      overflow hidden
      background-position 50%
      background-size cover
      background-repeat no-repeat
      background-color #fdfdfd
    +desktop()
      &:hover
        background blue_4
        *
          color #fff
    /.grid &
      margin-bottom 20px
  &.grid-3
  &.grid-4
    .content-boxes--item
      +between(100px, 600px)
        flex 0 0 100% !important
        border-right 0
      +between(600px, 1023px)
        flex 0 0 50% !important
        &:nth-child(2n)
          border-right 0
          .content-boxes--item--image
            padding-top calc(90% - 20px)
  &.grid-3
    .content-boxes--item
      +above(1024px)
        flex 0 0 33.33% !important
        &:nth-child(3n)
          border-right 0
          .content-boxes--item--image
            padding-top calc(90% - 20px)
  &.grid-4
    .content-boxes--item
      +between(1024px, 1200px)
        flex 0 0 33.33% !important
        &:nth-child(3n)
          border-right 0
          .content-boxes--item--image
            padding-top calc(90% - 20px)
      +above(1201px)
        flex 0 0 25% !important
        &:nth-child(4n)
          border-right 0
          .content-boxes--item--image
            padding-top calc(90% - 20px)


.pop-profile
  z-index 1005
  &--content
    center()
</style>
